//import { DataTransformations } from "../../../utils/data_transformations";
import { SELECTOR_TYPE, ROW_TYPE } from "./constants";
import { REQUEST_STATUS } from "../../reports/_utils/constants";

class CoreDataTransformations {
  static getOptionsBySelectorType(selectorType, rawOptions) {
    let options = [];
    if (!rawOptions) return options;

    switch (selectorType) {
      case SELECTOR_TYPE.UNIT_OBJECTS:
        rawOptions.forEach(o => {
          options.push({
            ...o,
            text: o.duid_name,
            value: o.element_no
          });
        });
        break;
      default:
        console.error("NOT IMPLEMENTED", selectorType);
    }
    return options;
  }

  //get disabled values based on options and selected data mode - 4s or 5m
  static getDisabledValues(options, dataMode) {
    let disabledValues = [];
    if (!options) return disabledValues;

    options.forEach(o => {
      if (o.endpoints && Object.keys(o.endpoints).indexOf(dataMode) < 0)
        disabledValues.push(o.value);
    });
    return disabledValues;
  }

  static getEnabledSelectedValues(options, selectedValues, dataMode) {
    const disabledValues = this.getDisabledValues(options, dataMode);
    return selectedValues
      ? selectedValues.filter(v => disabledValues.indexOf(v) < 0)
      : [];
  }

  static getReportTitle(report) {
    let reportTitle = "";
    if (report && report.name) {
      reportTitle += report.name;
      if (report.similarReportCounter && report.similarReportCounter > 0)
        reportTitle += ` (${report.similarReportCounter})`;
    }
    return reportTitle;
  }

  static getReportSubTitle(report, options, settings) {
    let reportTitle = "";
    if (report && options && settings) {
      const groupTypes = CoreDataTransformations.getGroupTypesFromReport(
        report
      );
      groupTypes.forEach(groupType => {
        const elements = CoreDataTransformations.getEnabledSelectedOptions(
          options[`${groupType}_objects`], //note this is objects not elements, should fix it
          report.groups[groupType].elements.selectedValues,
          settings.selectedDataMode
        );
        reportTitle += ` ${elements.map(e => e.text).join(", ")}`;
      });
    }

    return reportTitle;
  }

  static isReportLoading(report, requests) {
    if (report && requests) {
      const requestTime = report.requestTime;

      const requestIds = Object.keys(requests);
      for (let i = 0; i < requestIds.length; i++) {
        const request = requests[requestIds[i]];
        if (
          request.requestTime === requestTime &&
          request.status === REQUEST_STATUS.LOADING
        )
          return true;
      }
    }

    return false;
  }

  static getGroupTypesFromReport(report) {
    if (!report || !report.groups) return [];

    return Object.keys(report.groups);
  }

  static getEnabledSelectedOptions(options, selectedValues, dataMode) {
    const enabledSelectedValues = this.getEnabledSelectedValues(
      options,
      selectedValues,
      dataMode
    );
    return options && selectedValues
      ? options.filter(
          o =>
            enabledSelectedValues.indexOf(o.value) >= 0 ||
            enabledSelectedValues.indexOf(o.value && o.value.toString()) >= 0 //match on number or string
        )
      : [];
  }

  static getRowData(
    groupType,
    variables,
    objects,
    reportData,
    startingRowIndex
  ) {
    // console.log(
    //   "getRow data",
    //   rowLabel,
    //   variables,
    //   objects,
    //   reportData,
    //   startingRowIndex
    // );
    let data = [];

    if (objects && objects.length > 0) {
      //add row label
      data.push({
        rowType: ROW_TYPE.LABEL,
        text: groupType
      });
      objects.forEach(so => {
        //add  object row
        const rowCount = data.push({
          rowType: ROW_TYPE.OBJECT,
          groupType: groupType,
          text: so.text,
          data: reportData && reportData[so.value] ? reportData[so.value] : [],
          ...so
        });

        const refRowIndex = startingRowIndex + rowCount - 1;
        //add all variables for this object
        if (variables && variables.length > 0) {
          variables.forEach(sv => {
            data.push({
              ...sv, //////////////////////////////////////to check
              rowType: ROW_TYPE.VARIABLE,
              //text: sv.text,
              refRowIndex: refRowIndex,
              refColKey: sv.value
              // units: sv.units,
              // decimalPlaces: sv.decimalPlaces,
              // axisType: sv.axisType,
              // dataMode: sv.dataMode,
              // description: sv.description
            });
          });
        }
      });
    }

    return data;
  }

  //get csv format data from object data for report
  static getCsvDataFromJsonReportObject(objectData) {
    if (!objectData || objectData.length < 1) return;
    let csvData = [];
    const headerData = this.getTableReportHeaderData(objectData);
    if (headerData) {
      //      const dtLength = headerData.length;
      csvData.push(["Variables"].concat(headerData));
      objectData.forEach(d => {
        let row = [];
        if (d.rowType === ROW_TYPE.LABEL) {
          row.push(d.text.toUpperCase()); //col 1
        } else if (d.rowType === ROW_TYPE.OBJECT) {
          row.push(`${d.text} (${d.value})`); //col 1
          //no other data
        } else {
          row.push(`${d.text} (${d.units})`); //col 1
          //add other report data

          if (objectData[d.refRowIndex].data) {
            Object.keys(objectData[d.refRowIndex].data).forEach(dt => {
              row.push(objectData[d.refRowIndex].data[dt][d.refColKey]);
            });
          }
        }

        csvData.push(row);
      });
    }
    return csvData;
  }

  //get table header datetime data from object data
  static getTableReportHeaderData(data) {
    let headerData = null;
    if (data) {
      //get data for header and number of columns from  first object that as report data
      for (let i = 0; i < data.length; i++) {
        if (data[i] && data[i].data && Object.keys(data[i].data).length > 0) {
          headerData = Object.keys(data[i].data);
          break;
        }
      }
    }
    return headerData;
  }
}

export default CoreDataTransformations;



// WEBPACK FOOTER //
// ./src/views/core/_utils/coreDataTransformations.js